import { css } from "@compiled/react";

import { Flex, Box, xcss, media } from "@atlaskit/primitives";

const heroCompanyLogos = [
    {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/GALILEO-726-jpd-use-case-on-wac/canva.webp",
        alt: ""
    },
    {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/GALILEO-726-jpd-use-case-on-wac/square.webp",
        alt: ""
    },
    {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/GALILEO-726-jpd-use-case-on-wac/ebay.webp",
        alt: ""
    },
    {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/GALILEO-726-jpd-use-case-on-wac/dropbox.webp",
        alt: ""
    },
    {
        src: "https://wac-cdn.atlassian.com/misc-assets/webp-images/GALILEO-726-jpd-use-case-on-wac/cisco.webp",
        alt: ""
    }
];

const HeroCompanies = () => (
    <Flex wrap="wrap" gap="space.400" xcss={HeroCompaniesWrapper}>
        {heroCompanyLogos.map(({ src, alt }) => (
            <Box key={src}>
                <img src={src} alt={alt} css={HeroCompaniesLogoStyles} />
            </Box>
        ))}
    </Flex>
);

const HeroCompaniesWrapper = xcss({
    justifyContent: "center",
    width: "100%",
    paddingBlockEnd: "space.400",
    [media.above.sm]: {
        paddingBlockStart: "space.600"
    },
    [media.above.md]: {
        paddingBlockStart: "space.800",
        gap: "space.600"
    }
});

const HeroCompaniesLogoStyles = css({
    height: "24px",
    width: "auto",
    [media.above.sm]: {
        height: "32px"
    }
});

export default HeroCompanies;
